import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-black rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-light mb-3" }
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = { class: "col-lg-12" }
const _hoisted_7 = { class: "fv-row mb-5" }
const _hoisted_8 = {
  for: "newPassword",
  class: "form-label fs-6 fw-bolder mb-3 text-light"
}
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "col-lg-12" }
const _hoisted_12 = { class: "fv-row mb-5" }
const _hoisted_13 = {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3 text-light"
}
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "d-flex justify-content-center" }
const _hoisted_17 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_18 = { class: "indicator-label" }
const _hoisted_19 = { class: "indicator-progress" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_21 = { class: "d-flex flex-wrap justify-content-center pb-lg-0 mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("changePassword")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("min6characters")), 1)
    ]),
    _createVNode(_component_Form, {
      id: "kt_signin_change_password",
      class: "form",
      novalidate: "novalidate",
      onSubmit: _ctx.updatePassword,
      "validation-schema": _ctx.changePassword
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("newPassword")), 1),
              _createVNode(_component_Field, {
                type: "password",
                class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                name: "newPassword",
                id: "newPassword"
              }),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ErrorMessage, { name: "newPassword" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("newPasswordRequired")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("confirmNewPassword")), 1),
              _createVNode(_component_Field, {
                type: "password",
                class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                name: "confirmpassword",
                id: "confirmpassword"
              }),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_ErrorMessage, { name: "confirmpassword" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("repeatPasswordNotIdentical")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("updatePassword")), 1),
            _createElementVNode("span", _hoisted_19, [
              _createTextVNode(_toDisplayString(_ctx.$t("sending")) + " ", 1),
              _hoisted_20
            ])
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_router_link, {
        to: "/sign-in",
        class: "text-light fw-bolder"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("msgLogin")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}